import styled from "styled-components";

import { WidgetFrameContent } from "@/components/layout/WidgetFrame/WidgetFrameContent";

const WidgetFrameGridContent = styled(WidgetFrameContent)`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 1.5rem;

    padding-top: 1rem;
    padding-bottom: 1rem;

    background-color: ${({ theme }) => theme.color.dairyLight};

    > div {
        box-shadow: none;
    }
`;

export { WidgetFrameGridContent };
